import { render, staticRenderFns } from "./TextContent.vue?vue&type=template&id=367eb140&scoped=true&"
import script from "./TextContent.vue?vue&type=script&lang=js&"
export * from "./TextContent.vue?vue&type=script&lang=js&"
import style0 from "./TextContent.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TextContent.vue?vue&type=style&index=1&id=367eb140&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367eb140",
  null
  
)

export default component.exports